import React, { useState } from "react";
import { loginUser } from "../store/thunk/loginUser";
import { useDispatch } from "react-redux";
import { fetchCart } from "../store/thunk/fetchCart";
import { saveStorage } from "../Utils/Utils";

function LoginModal(props) {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showVerifyMessage, setShowVerifyMessage] = useState(false);
    const [isLoading,setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const onClickRegister = () =>{
        props.setOpenLoginModal(false);
        props.setOpenRegisterModal(true);
    }
    const onClickClose = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setEmail('');
        setPassword('');
        setShowErrorMessage(false);
        setShowVerifyMessage(false);
        setIsLoading(false);
    }

    const onClickLogin = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (email?.length && password?.length) {
            const loginDetails = {
                Email: email,
                Password: password
            }
            const closeBtn = document.getElementById('closeModal');
            const closeMobileHeader = document.getElementById('closeMobileHeader');
            dispatch(loginUser(loginDetails)).then((response) => {
                if (response.payload?.emailVerificationPending) {
                    setShowVerifyMessage(true);
                    setShowErrorMessage(false);
                    setIsLoading(false);
                } else if (response.payload?.token) {
                    saveStorage("token", response.payload.token);
                    dispatch(fetchCart(response.payload?.id));
                    setShowErrorMessage(false);
                    setShowVerifyMessage(false);
                    closeBtn.click();
                    props.setOpenLoginModal(false);
                    closeMobileHeader.click();
                } else {
                    setShowErrorMessage(true);
                    setShowVerifyMessage(false);
                    setIsLoading(false);
                }
            }).catch(() => {
                setShowErrorMessage(true);
                setIsLoading(false);
            });
        }
    }

    return (
        <div className="modal clean_modal clean_modal-lg" id="login_modal" tabindex="-1" aria-labelledby="login_modal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <button type="button" id='closeModal' className="close" data-dismiss="modal" aria-label="Close" onClick={(e)=>onClickClose(e)} >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="ModalHeader text-muted my-4">Login</p>
                            </div>
                        </div>
                        {showErrorMessage &&
                            <div className="login_error">
                                <div className="alert alert-danger" role="alert">
                                    Invalid email or password.
                                </div>
                            </div>}
                        {showVerifyMessage &&
                            <div className="login_error">
                                <div className="alert alert-warning" role="alert">
                                    Please verify your email before logging in. Check your inbox for a verification link.
                                </div>
                            </div>}
                        <form onSubmit={(e) => onClickLogin(e)} id="login_modal_form">
                            <div className="form-group">
                                <input name="email" required type="email" placeholder="Email"
                                    className="form-control input-lg rounded" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <input name="password" required type="password" placeholder="Password"
                                    className="form-control input-lg rounded" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <button className="btn btn-primary btn-full btn-medium rounded" type="submit" disabled={isLoading}>
                                <span className={`${isLoading ? `spinner-border` : ``} spinner-border-sm`} role="status" aria-hidden="true"></span>
                                Login
                            </button>
                            {/* <button id="login_btn" name="submit" type="submit"
                                className="btn btn-primary btn-full btn-medium rounded" >Login</button> */}
                            <div className="form-group text-center small font-weight-bold mt-3">
                                {/* <a className = 'linkClass1' data-toggle="modal" data-dismiss="modal" data-target="#forgot_modal"> Forgot
                                    Password?</a> */}
                            </div>
                            <hr className="my-4" />
                            <div className="form-group text-center small font-weight-bold mb-0">
                                Don&apos;t have an account? <a href="#" className="linkClass1" data-toggle="modal" data-dismiss="modal"
                                    data-target="#register_modal" onClick={onClickRegister}> Register</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default LoginModal